<template>
  <div class="container">
    <div class="image-wrapper">
      <!--<i class="el-icon-success icon" v-if="!!image.class_id"></i>-->
      <div v-if="checkMode" class="mask-wrapper" @mouseenter="imageOnHover" @mouseleave="imageOnBlur">
        <i  class="el-icon-delete  icon-btn" v-if="iconShow" @click="handleUnmark"></i>
        <div class="btn-wrapper" v-if="iconShow">
          <el-popover
            class="btn"
            ref="popover1"
            placement="top-start"
            @show="popoverShow"
            @hide="popoverHide"
            trigger="click">
            <span @mouseenter="imageOnHover">
              <img :src="image.dish_img_url" alt="" width="300">
              <div class="check-text" v-if="image.checkText">{{image.checkText}}</div>
            </span>
            <el-button type="text" class="btn" icon="el-icon-search" slot="reference"></el-button>
          </el-popover>
          <el-popover
            class="btn btn-right"
            ref="popover1"
            placement="top-start"
            trigger="click"
            @show="popoverShow"
            @hide="popoverHide"
          >
            <regions-wrapper v-if="regionsShow" :regions="regions" :image="regionImageUrl"></regions-wrapper>
            <el-button type="text" class="btn" icon="el-icon-info" slot="reference" @click="getImageRegion"></el-button>
          </el-popover>
        </div>
      </div>
      <img
        v-lazy="image.dish_img_url"
        :src="image.dish_img_url"
        class="image-item"/>
    </div>
  </div>
</template>
<script>
import {apiGetRegionImgByUuid} from '@/api';
import regionsWrapper from './imageRegionWrapper';

export default {
  name: 'imageItem',
  components: {
    regionsWrapper
  },
  props: {
    optionShow: true,
    image: {
      type: Object,
      default () {
        return {};
      }
    },
    checkMode: true,
    selfCheck: false,
    dish_img_uuid: '',
    modelList: {
      type: Array,
      default () {
        return [];
      }
    }

  },
  data () {
    return {
      popoverIsShow: false,
      iconShow: false,
      regions: [],
      regionImageUrl: '',
      regionsShow: false
    };
  },
  mounted () {

  },
  methods: {
    popoverShow () {
      console.log('saaaaaaaaaaaaaaaa');
      this.popoverIsShow = true;
      this.regionsShow = true;
    },
    popoverHide () {
      console.log('asssssssssssssssssss');
      this.popoverIsShow = false;
      this.regionsShow = false;
    },
    async getImageRegion () {
      try {
        let res = await apiGetRegionImgByUuid(this.image.dish_img_uuid);
        this.regionImageUrl = res.region_img_url;
        this.regions = res.region_img_regions;
      } catch (e) {

      }
    },
    handleDelete () {
      this.$confirm('是否删除此图片?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消'
      }).then(() => {
        this.$emit('delete', {dish_img_uuid: this.dish_img_uuid});
        this.$message({
          type: 'success',
          message: '删除成功'
        });
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '您已取消删除'
        });
      });
    },
    imageOnHover () {
      this.iconShow = true;
    },
    imageOnBlur () {
      if (this.popoverIsShow) {

      } else {
        this.iconShow = false;
      }
    },
    handleUnmark () {
      this.$emit('delete', this.dish_img_uuid);
    }
  },
  computed: {
    selfChecked () {
      return this.$route.query.selfCheck;
    },
    dish_img_uuidShow () {
      return this.$router.currentRoute.name === 'checkProcess' && this.selfCheck === true;
    }
  },
  watch: {
    popoverIsShow (val) {
      if (!val) {
        this.iconShow = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
  .container {
    margin-bottom: 10px;
    .image-wrapper {
      position: relative;
      width: 80px;
      height: 80px;
      vertical-align: top;
      position: relative;
      display: inline-block;
      text-align: center;
      .icon {
        position: absolute;
        top: 0;
        right: 0;
        color: #13ce66;
        font-size: 30px;
        background-color: #fff;
        border-radius: 50%;
      }
      .mask-wrapper {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        right: 0;
        line-height: 100px;
        cursor: pointer;
        text-align: center;
        .btn-wrapper {
          position: absolute;
          right: 0px;
          top: 0;
          width: 100%;
          height: 30px;
          z-index: 100;
          line-height: 30px;
          .btn {
            display: inline-block;
            float: left;
            &.btn-right {
              float: right
            }
          }

        }
        .check-text {
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          width: 70px;
          height: 20px;
          line-height: 20px;
          display: inline-block;
          font-size: 16px;
          padding: 5px;
          border-radius: 10px;
          color: #ccc;
          background-color:rgba(0, 0, 0, 0.5);
        }
        .icon-btn {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          line-height: 80px;
          text-align: center;
          font-size: 26px;
          font-weight: bold;
          color: #fff;
          &.el-icon-circle-plus-outline {
            color: #00ff00;
          }
          &.el-icon-delete {
            color: #ff0000;
          }
        }
        &:hover {
          background-color: rgba(0, 0, 0, 0.3);
        }
      }

    }
  }
</style>
